import React from 'react'
import styled from 'styled-components'
import { useTranslation, Trans } from 'react-i18next'
import { colors, fontWeights } from '@/styles'
import { RedLock } from '@/components/icons'

const Container = styled.div`
  display: flex;
  padding: 18px 17px;
  margin: 16px 0;
  background: ${colors.white};
  position: sticky;
  top: 0px;
  border: 1px ${colors.grey88};
  border-left: 6px solid ${colors.red64};
  z-index: 1;

  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1), 0px 1px 2px rgba(0, 0, 0, 0.06);
  border-radius: 4px;
`

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 15px;
`

const Title = styled.span`
  font-size: 14px;
  font-weight: ${fontWeights.medium};
  margin-bottom: 8px;
`

const Description = styled.p`
  font-size: 14px;
  line-height: 20px;
  margin-top: ${props => (props.top ? props.top : '0')}px;
  margin-bottom: 0;
`

const ActionText = styled.span`
  color: ${colors.link};
  text-decoration: underline;
  cursor: pointer;
`

const StyledRedLock = styled(RedLock)`
  flex-shrink: 0;
`

const LockedBanner = ({
  isLandlord = false,
  handleDelete,
  hasApplication,
  handleCopyApplicant
}) => {
  const { t } = useTranslation()
  return (
    <Container>
      <StyledRedLock />
      <TextContainer>
        <Title>{t('b.chat.view.chat_locked.title', 'Chat Locked')}</Title>
        <Description top={8}>
          {isLandlord
            ? t(
                'b.chat.view.chat_locked.description_landlord',
                'You can’t send or receive messages in this chat because a tenant was found, the listing was marked as rented, and/or the chat has been deleted by the renter.'
              )
            : t(
                'b.chat.view.chat_locked.description_renter',
                'You can’t send or receive messages in this chat because a tenant was found, the listing was marked as rented, and/or the chat has been deleted by the landlord.'
              )}
        </Description>
        {isLandlord && (
          <Description top={4}>
            {hasApplication ? (
              <Trans i18nKey="l.chat.view.chat_locked_options.text">
                You can{' '}
                <ActionText onClick={handleCopyApplicant}>
                  copy this applicant to another listing
                </ActionText>{' '}
                or <ActionText onClick={handleDelete}>delete this chat</ActionText>.
              </Trans>
            ) : (
              <Trans i18nKey="l.chat.view.chat_locked_options_no_applicant.text">
                You can <ActionText onClick={handleDelete}>delete this chat</ActionText>.
              </Trans>
            )}
          </Description>
        )}
      </TextContainer>
    </Container>
  )
}

export default LockedBanner
